<div class="d-flex mb-2 fw-bold justify-content-end mx-2">
  <div *ngIf="showAssetFilter$ | async">
    <i class="pi pi-box"></i>
    {{ selectedAssetName$ | async }}
  </div>
  <div *ngIf="showTimeSelector$ | async" class="mx-2">|</div>
  <div *ngIf="showTimeSelector$ | async">
    <i class="pi pi-calendar-minus"></i>
    {{ dateRangeMinDateFormatted$ | async }} through
    {{ dateRangeMaxDateFormatted$ | async }}
  </div>
</div>
